/**
 * scanSettings — localStorage utility for scan resolution tier.
 *
 * Users choose "Standard (HD)" or "Ultra (4K)" before scanning.
 * This persists their choice per device.
 */

export type ResolutionTier = 'standard' | 'ultra'

interface ScanSettings {
  resolutionTier: ResolutionTier
}

const STORAGE_KEY = 'dukkan-scan-settings'

const DEFAULTS: ScanSettings = {
  resolutionTier: 'standard',
}

export function getScanSettings(): ScanSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULTS }
    const parsed = JSON.parse(raw)
    // Validate resolutionTier
    if (parsed.resolutionTier !== 'standard' && parsed.resolutionTier !== 'ultra') {
      return { ...DEFAULTS }
    }
    return { ...DEFAULTS, ...parsed }
  } catch {
    return { ...DEFAULTS }
  }
}

export function setScanSettings(settings: Partial<ScanSettings>): void {
  const current = getScanSettings()
  const merged = { ...current, ...settings }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
}
